// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8nD6x","label":"styles_label__1uWmo"};